<template>
  <PerfectScrollbar class="AllPwaMobile">
    <div style="max-width: 100%; margin: auto">
      <div class="page-f">


        <div class="AllPwaMobileClass">
          <div @click="ChnageBtn" :style="style1" class="ChildAllPwaMobileClass">
            همه
          </div>
          <div @click="ChnageBtn1" :style="style2" class="ChildAllPwaMobileClass">
            واریزی
          </div>
          <div @click="ChnageBtn2" :style="style3" class="ChildAllPwaMobileClass">
            پرداختی
          </div>
        </div>

        <div  v-if="step == 1" style="padding:5px">
          <div  v-if="SearchList.length>0&&!loading">
          <div class="ShowSearchLists" v-for="(SearchLists,index) in SearchList"   :key="index">

            <div >
              <div class="ShowPriceSearchT" v-if="SearchLists.type_en != 'dec'">
                <span style="color: #70ea70">{{SearchLists.new_credit}} تومان</span>
                <p >مبلغ</p>
              </div>

              <div class="ShowPriceSearchT" v-if="SearchLists.type_en == 'dec'">
                <span style="color: #fa8686">{{SearchLists.amount}} تومان</span>
                <p >مبلغ</p>
              </div>

              <div style="border: 1px dashed #70ea70" v-if="SearchLists.type_en != 'dec'" class="DotShowPriceSearchT"></div>
              <div style="border: 1px dashed #fa8686" v-if="SearchLists.type_en == 'dec'" class="DotShowPriceSearchT"></div>

              <div class="ShowPriceSearchT">
                <div>{{SearchLists.new_credit}} تومان</div>
                <p >موجودی</p>
              </div>
            </div>
            <hr />

            <h4>مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}}
              <span style="color: #70ea70" v-if="SearchLists.type_en != 'dec'">واریز</span>
              <span style="color: #fa8686" v-if="SearchLists.type_en == 'dec'">پرداخت</span>
              گردید</h4>
          </div>
          </div>
          <div v-if="SearchList.length>0&&loadmore&&!loading" @click="ReloadMethods()" class="LoadLazyAdd mb-3">
            نمایش بیشتر
          </div>
          <div v-if="SearchList.length==0&&!loading" class="justify-center align-center mt-3" style="text-align: center">
              <img src="@/assets/img/notfound.png" alt="Alt text" width="320" height="280" />
          </div>
          <div v-if="SearchList.length === 0 && loading" class="flex justify-content-center align-items-center" style="height: 90%;">
            <Skeletor v-for="v in 4" :key="v" style="border-radius: 5px;width: 100%;height: 130px;margin: 10px 0;" />
          </div>







        </div>

        <div  v-if="step == 2 ">
          <div v-if="SearchList1.length>0&&!loading">
          <div class="ShowSearchLists"  v-for="(SearchLists,index) in SearchList1" :key="index">

            <div >
              <div class="ShowPriceSearchT">
                <span style="color: #70ea70">{{SearchLists.amount}} تومان</span>

                <div >مبلغ</div>
              </div>

              <div style="border: 1px dashed #70ea70" class="DotShowPriceSearchT"></div>

              <div class="ShowPriceSearchT">
                <span>{{SearchLists.new_credit }} تومان</span>

                <div >موجودی</div>
              </div>
            </div>
            <hr />
            <h4>مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}} <span style="color: #70ea70" v-if="SearchLists.type_en != 'dec'">واریز</span> گردید</h4>
          </div>
          </div>
          <div v-if="SearchList1.length>0&&loadmore&&!loading" @click="ReloadMethods1()" class="LoadLazyAdd mb-3">
            نمایش بیشتر
          </div>
          <div v-if="SearchList1.length === 0 && !loading" class="flex justify-content-center align-items-center" style="text-align: center">
            <img src="@/assets/img/notfound.png" alt="Alt text" width="320" height="280" />
          </div>
          <div v-if="SearchList1.length === 0 && loading" class="flex justify-content-center align-items-center" style="height: 90%;">
            <ProgressSpinner style="width: 82px; height: 82px; margin-top: 10rem;" strokeWidth="8" />
          </div>
        </div>

        <div  v-if="step == 3 ">
          <div v-if="SearchList2.length>0&&!loading">
          <div class="ShowSearchLists"  v-for="(SearchLists,index) in SearchList2" :key="index" >

            <div >
              <div class="ShowPriceSearchT">
                <span style="color: #fa8686">{{SearchLists.amount}} تومان</span>
                <p >مبلغ</p>
              </div>

              <div style="border: 1px dashed #fa8686" class="DotShowPriceSearchT"></div>

              <div class="ShowPriceSearchT">
                <span>{{SearchLists.new_credit}} تومان</span>
                <p >موجودی</p>
              </div>
            </div>
            <hr />
            <h4>مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}} <span style="color: #fa8686" v-if="SearchLists.type_en == 'dec'">پرداخت</span> گردید</h4>
          </div>
          </div>
          <div v-if="SearchList2.length>0&&loadmore&&!loading" @click="ReloadMethods2()" class="LoadLazyAdd mb-3">
            نمایش بیشتر
          </div>
          <div v-if="SearchList2.length === 0 && !loading" class="flex justify-content-center align-items-center" style="text-align: center">
            <img src="@/assets/img/notfound.png" alt="Alt text" width="320" height="280" />
          </div>
          <div v-if="SearchList2.length === 0 && loading" class="flex justify-content-center align-items-center" style="height: 90%;">
            <ProgressSpinner style="width: 82px; height: 82px; margin-top: 10rem;" strokeWidth="8" />
          </div>
        </div>
      </div>
    </div>
  </PerfectScrollbar>
</template>

<script>
import { mapGetters } from 'vuex';
import {PerfectScrollbar} from "vue3-perfect-scrollbar";
export default {
  components: {
    PerfectScrollbar,
  },
  data(){
    return{
      step : 1,
      SearchList : [],
      SearchList1 : [],
      SearchList2 : [],
      PageShow : 0,
      PageShow1 : 0,
      PageShow2 : 0,
      time : '',
      loadmore:false,
      loading:true,

      style3: "",
      style2: "",
      style1: "border-bottom: 2px solid #68A1FF;",
    }
  },
  computed: {
    ...mapGetters([ "auth_taxi"]),
  },

  mounted() {
    this.ReloadMethods();
    this.ReloadMethods1();
    this.ReloadMethods2();
    this.ChnageBtn();
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods:{
    ReloadMethods(){
        let self=this
      this.loadmore=true;
      this.PageShow += 1;

      this.helperGet_taxi('get-customer-credit-history', 'type=' + "all" + '&uid=' + self.$store.state.auth_taxi.uid + '&page=' + self.PageShow)
          .then(json => {
            if (json.result == 0){
                self.PageShow -= 1
            }else {

              // json.data.data.list.forEach((value) => {
              //   this.SearchList.push(value);
              // });
              this.SearchList= this.SearchList.concat(json.data.data.list);

              if (json.data.data.total_page==this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })
    },
    ReloadMethods1(){
      this.PageShow1 += 1
        let self=this
      this.helperGet_taxi('get-customer-credit-history',  'type=' + "inc" + '&uid=' + self.$store.state.auth_taxi.uid+ '&page=' + this.PageShow1)
          .then(json => {
            if (json.result == 0){
              this.PageShow1 -= 1
            }else {
              // json.data.data.list.forEach((value) => {
              //   this.SearchList1.push(value);
              // });

              this.SearchList1= this.SearchList1.concat(json.data.data.list);

              if (json.data.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })


    },
    ReloadMethods2(){
      this.PageShow2 += 1
        let self=this
      this.helperGet_taxi('get-customer-credit-history',  'type=' + "dec" + '&uid=' + self.$store.state.auth_taxi.uid + '&page=' + this.PageShow2)
          .then(json => {
            if (json.result == 0){
              this.PageShow2 -= 1
            }else {
              // json.data.data.list.forEach((value) => {
              //   this.SearchList2.push(value);
              // });

              this.SearchList2= this.SearchList2.concat(json.data.data.list);

              if (json.data.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })


    },
    ChnageBtn(){
      this.style1 = "border-bottom: 2px solid #68A1FF;"
      this.style2 = ""
      this.style3 = ""
      this.step = 1
    },
    ChnageBtn1(){
      this.style2 = "border-bottom: 2px solid #68A1FF;"
      this.style1 = ""
      this.style3 = ""
      this.step = 2
    },
    ChnageBtn2(){
      this.style3 = "border-bottom: 2px solid #68A1FF;"
      this.style1 = ""
      this.style2 = ""
      this.step = 3
    },
  }
};
</script>

<style scoped>
.MyClassUpdate{
  display: grid;
  grid-template-columns: 31% 31% 31%;
  justify-content: space-between;
  padding: 0 10px;
  padding-top: 20px;
}

.LoadLazyAdd{
  margin: auto;
  width: 50%;
  height: 40px;
  border-radius: 30px;
  text-align: center;
  background: rgb(86, 146, 183);
  margin-top: 30px;
  line-height: 38px;
  color: white;
  cursor: pointer;
}
.page-f{
  height: calc(100vh - 56px);
  overflow: auto;

}
</style>


